import { SplashPanel } from '~/components';
import { useView, trackPageView } from '~/hooks';
import cn from 'classnames';
import { useEffect, ReactElement } from 'react';
import { Views } from '~/utilities/constants';
import { hasFeatureFlag } from '@janeapp/feature-flags-client';

interface SplashProps {
  analyticsInitialized: boolean;
  locationInput: ReactElement;
}

export function Splash({ analyticsInitialized, locationInput }: SplashProps) {
  const { view } = useView();
  const isNorthVanBetaEnabled = hasFeatureFlag('NORTH_VANCOUVER_BETA');

  useEffect(() => {
    if (analyticsInitialized) {
      trackPageView('mpl_splash_page_viewed', {
        path: window.location.pathname,
      });
    }
  }, [analyticsInitialized]);

  return (
    <div
      data-testid="splash-page"
      className={cn(
        'mobile-safe-area-insets h-dvh w-dvw',
        view !== Views.List ? 'grid-container has-details' : ''
      )}
    >
      <SplashPanel locationInput={locationInput} />
      <div
        data-testid="splash-img"
        role="img"
        aria-label="Panoramic photograph of man hiking The Chief in Squamish, BC"
        className={cn(
          'grid-area-map focus-within:outline-none focus:outline-none',
          isNorthVanBetaEnabled
            ? 'splash-img-north-van'
            : 'splash-img-squamish',
          view !== Views.List ? 'grid' : 'hidden'
        )}
      />
    </div>
  );
}
